// @flow

import "cross-fetch/polyfill"

import type {ApiMethod, ApiResponse, Error} from "./types"
import Sentry from "./services/sentry"
import Config from "./config"
// TODO could be in flow-typed, check once in a while
// declare Raven:any;

export const credentials = "same-origin"

export const client = (token: string) => {
  const defaultClient = {token: null}
  return {...defaultClient, token}
}

export const buildHeaders = () => {
  const defaultHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
  }
  const authHeaders = {
    Authorization: `Bearer ${Config.jwt}`,
  }
  return {...defaultHeaders, ...authHeaders}
}

export const buildHeadersMultipart = () => {
  const defaultHeaders = {Accept: "application/json"}
  const authHeaders = {Authorization: `Bearer ${Config.jwt}`}
  return {...defaultHeaders, ...authHeaders}
}

export const get = (url: string): Promise<*> => request("GET", url)

export const post = (url: string, data: Object = {}): Promise<*> =>
  request("POST", url, data)

export const put = (
  url: string,
  data: Object = {},
  multipart: boolean = false
): Promise<*> => request("PUT", url, data, multipart)

export const del = (url: string, data: Object = {}): Promise<*> =>
  request("DELETE", url, data)

// opts: ApiClientOptions = {}
const request = (
  method: ApiMethod,
  url: string,
  data: ?Object = null,
  multipart?: boolean = false
): Promise<*> => {
  return fetch(`${Config.apiUrl}${url}`, {
    method,
    headers: !multipart ? buildHeaders() : buildHeadersMultipart(),
    credentials,
    body: data && !multipart ? JSON.stringify(data) : data,
  })
    .then(checkStatus)
    .then((response) => parseResponse(response))
}

export const handleHttpError = (error: Error, props: Object = {}) => {
  console.warn("[API ERROR]")
  console.log(error)
  console.warn(error.response)
  const url = error.response ? error.response.url : ""
  Sentry.captureException(error, {url, props})
}

const checkStatus = (response: Response): Promise<Response> => {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response)
  }
  if (response.status === 503) {
    window.location.reload()
    return Promise.reject(response.json())
  }
  if (response.status === 422) {
    return Promise.reject(response.json())
  }
  const error = new Error(response.statusText)
  error.response = response
  error.status = response.status
  throw error
}

// TODO could we be more specific about the promise type?
const parseJSON = (response: Response): Promise<ApiResponse> => response.json()

export const parseResponse = async (response: Response): Promise<ApiResponse> =>
  await parseJSON(response)
